import {
  createApplicationRoutes,
  provideFramework,
  provideSoftappsCore,
} from '@configs/common';
import { provideHagebauPartnerSoftlineModules } from '@configs/hagebau-partner';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { platform } from '../platforms/platform';
import { eslConfigRoutes, provideEslConfigModule } from '@softapps/handel/esl-config';
import {
  eslLinkStorageRoutes,
  eslSearchRoutes,
  provideEslLinkStorageProviders,
  provideEslSearchProviders,
} from '@softapps/handel/esl-link-storage';
import { offenePostenRoutes } from '@softapps/fibu/offene-posten';
import {
  provideStorageLocation,
  storageLocationRoutes,
} from '@softapps/mde/storage-location';
import {
  abcAnalysisRoutes,
  provideABCAnalysisProviders,
} from '@softapps/lager/abc-analysis';

const [providers, routes] = provideSoftappsCore({
  userContext: true,
  contextStorage: true,
  pdfViewer: true,
  remoteConfig: true,
  vkforgContext: true,
});

const [hagebauProviders, hagebauRoutes] = provideHagebauPartnerSoftlineModules();

hagebauRoutes.internal.push(...storageLocationRoutes);
hagebauRoutes.internal.push(...eslLinkStorageRoutes);
hagebauRoutes.internal.push(...eslConfigRoutes);
hagebauRoutes.internal.push(...eslSearchRoutes);
hagebauRoutes.internal.push(...abcAnalysisRoutes);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      createApplicationRoutes(routes, hagebauRoutes, {
        internal: [
          ...eslConfigRoutes,
          ...eslLinkStorageRoutes,
          // ...eslLinkRoutes,
          ...offenePostenRoutes,
        ],
        public: [],
      })
    ),

    ...provideFramework(environment.connection),
    ...providers,
    ...hagebauProviders,

    // ...eslLinkProviders,
    ...provideEslLinkStorageProviders({ storageSelection: true }),
    ...provideStorageLocation(),
    ...provideEslConfigModule(),
    ...provideEslSearchProviders(),
    ...provideABCAnalysisProviders(),

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
